import { apiFetch } from "./client";
import type { ManagerDrilldownResponse, SupervisorSummary } from "./types";

/**
 * S1/S2 Homes — Supervisor Home. The 3-block team summary rides on the same
 * /home-summary?scope=team payload (backend embeds `supervisorSummary` only for a
 * supervisor-tier user with a team; otherwise the key is absent → null here).
 */
export async function fetchSupervisorSummary(
  signal?: AbortSignal,
): Promise<SupervisorSummary | null> {
  const res = await apiFetch<{ supervisorSummary?: SupervisorSummary }>(
    "/Custom/frontend/home-summary",
    { query: { scope: "team" }, signal },
  );
  return res.supervisorSummary ?? null;
}

/** Manager Drilldown (C4) — out-of-team / non-supervisor → 403 (backend-enforced). */
export function fetchManagerDrilldown(
  managerId: string,
  signal?: AbortSignal,
): Promise<ManagerDrilldownResponse> {
  return apiFetch<ManagerDrilldownResponse>(
    "/Custom/frontend/supervisor/manager-drilldown",
    { query: { managerId }, signal },
  );
}
